/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import Subject from '../../rx/Subject';
import IPeerConnection from '../../rtc/IPeerConnection';

export default class PeerConnectionContext {
  mediaStream: Subject<MediaStream | null>;
  peerConnection: Subject<IPeerConnection | null>;
  peerConnectionReconnectAttempts: number;

  constructor() {
    this.mediaStream = new Subject<MediaStream | null>(null);
    this.peerConnection = new Subject<IPeerConnection | null>(null);
    this.peerConnectionReconnectAttempts = 0;
  }
}